import config from "../../../helpers/config";

const AccountLinkedInstructions = () => {
  const reloadApp = () => {
    window.location.reload();
  };

  const { webUrl } = config;
  const peerToPeerUrl = `${webUrl}/dashboard/create-rewards/peer-to-peer`;

  return (
    <>
      <p>
        Account Linked. Please go back to your Zuzo dashboard to sync your Team
        members.
      </p>

      <div style={{ display: "flex" }}>
        <a
          className="btn-mint dashboard-links"
          href={peerToPeerUrl}
          target="_blank"
        >
          Go to Zuzo dashboard
        </a>
      </div>
      <div style={{ display: "flex", marginTop: 12 }}>
        <a
          className="btn-mint-outline dashboard-links"
          onClick={() => {
            reloadApp();
          }}
        >
          Reload this page
        </a>
      </div>
    </>
  );
};

export default AccountLinkedInstructions;
